export const APP_NAME = 'App'
